import React, { FC } from 'react';
import { ReactComponent as AiSvg } from 'assets/ai.svg';
import TooltipPoratal from 'components/UI/TooltipPoratal';
import { useTranslation } from 'react-i18next';
import css from '../styles.module.scss';

interface IConversionIconProps {
  isDisabled: boolean;
  onMouseDown?: React.MouseEventHandler<SVGSVGElement>;
}

const ConversionIcon: FC<IConversionIconProps> = ({
  isDisabled = false,
  onMouseDown,
}) => {
  const { t } = useTranslation();

  return (
    <TooltipPoratal
      hintWidth={250}
      classname={css.conversion__tooltip}
      hint={t(`conversion_link`)}
      isDisabled={isDisabled}
    >
      <AiSvg className={css.conversion__icon} onMouseDown={onMouseDown} />
    </TooltipPoratal>
  );
};

export default ConversionIcon;
